import {useQuery} from "@tanstack/react-query";
import {getHomeSectionsService} from "../../services/homeSections/homeSections.service";

export const HOME_SECTIONS_QUERY_KEY = ["homeSections", "home"];

/**
 * @param {boolean} enabled - Only fetch when home layout feature flag is on.
 */
export const useGetHomeSections = (enabled = false) => {
  const {data, isPending, isError, isFetching} = useQuery({
    queryKey: HOME_SECTIONS_QUERY_KEY,
    queryFn: () => getHomeSectionsService("home"),
    enabled,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    select: response => response?.data?.data ?? [],
  });

  return {
    sections: data ?? [],
    isPending,
    isError,
    isFetching,
  };
};
